const stepAfterMillion = 100000

 export const getBudgetNumber = number => {
  if(number >= 1000000){
    return Math.ceil(number/stepAfterMillion)*stepAfterMillion
  }
  return number
}
